hideUserMenu